import { useState } from 'react';

import PropTypes from 'prop-types';

import { Box, Checkbox, FormControlLabel, Menu } from '@mui/material';

import { HIDDEN_TABLE_IDS } from './constants';

import { ButtonLink } from '../Button';

const ColumnsVisibilityComponent = ({
  tableId,
  columns,
  hiddenColumnsIds,
  onHiddenColumnsChange,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  if (HIDDEN_TABLE_IDS.includes(tableId)) return null;
  if (columns.length < 2) return null;

  const visibleColumns = columns.filter(
    ({ show, isExpander }) => show !== false && !isExpander,
  );
  const hasHiddenColumns = Boolean(hiddenColumnsIds.length);

  return (
    <Box position="absolute" zIndex="1" right="0" sx={{ top: '-32px' }}>
      <ButtonLink
        id="columns-visibility"
        aria-controls={open ? 'columns-list' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        {hasHiddenColumns && '*'}Columns
      </ButtonLink>
      <Menu
        id="columns-list"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: (theme) => ({
            border: '0.1rem solid #CFCFCF',
            borderRadius: '1rem',
            backgroundColor: theme.palette.common.white,
          }),
        }}
        MenuListProps={{
          'aria-labelledby': 'columns-button',
        }}
      >
        {visibleColumns.map(({ id, Header }) => {
          const isChecked = !hiddenColumnsIds?.includes(id);
          const isLastShown =
            hiddenColumnsIds.length + 1 >= visibleColumns.length;
          return (
            <FormControlLabel
              control={
                <Checkbox
                  checked={isChecked}
                  onChange={(e) => onHiddenColumnsChange(e, id)}
                />
              }
              label={<div>{Header}</div>}
              disabled={isChecked && isLastShown}
              key={id}
              sx={{ display: 'flex', marginLeft: '0.5rem' }}
            />
          );
        })}
      </Menu>
    </Box>
  );
};

ColumnsVisibilityComponent.propTypes = {
  tableId: PropTypes.string.isRequired,
  columns: PropTypes.instanceOf(Array).isRequired,
  hiddenColumnsIds: PropTypes.instanceOf(Array).isRequired,
  onHiddenColumnsChange: PropTypes.func.isRequired,
};

export default ColumnsVisibilityComponent;
